/**
 * @typedef {Object} RawItemSku
 * @property {string} id
 * @property {string} name
 * @property {{imageUrl: string}} itemSkuImage
 * @property {{display: boolean, soldOut: boolean}} itemSkuSalesCondition
 * @property {{price: number, shippingCost: number}|null} itemSkuAccountingCondition
 * @property {{displayTaxType: number}|null} itemSkuDetail
 *
 * @typedef {Object} ItemSku
 * @property {string} id
 * @property {string} name
 * @property {string} imageUrl
 * @property {number} price 送料込みの価格
 * @property {boolean} isIncludingTax
 * @property {boolean} soldOut
 */

/**
 * SKUレスポンスを送料込みの価格と表示情報へ正規化する。
 * @param {RawItemSku} sku 経理情報があるSKU
 * @returns {ItemSku}
 */
export const toItemSku = sku => ({
  id: sku.id,
  name: sku.name,
  imageUrl: sku.itemSkuImage.imageUrl,
  price:
    sku.itemSkuAccountingCondition.price +
    sku.itemSkuAccountingCondition.shippingCost,
  isIncludingTax: sku.itemSkuDetail?.displayTaxType === 1,
  soldOut: sku.itemSkuSalesCondition.soldOut
})
